import React from "react";
import { MarketInformation } from "../api/contentful";
import "./MarketHomeCardBody.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

function formatMarketHours(startTime: string, endTime: string): string {
  return `${startTime}–${endTime}`;
}

function buildMapsUrl(market: MarketInformation): string {
  const query = market.address?.trim();
  if (query) {
    return `https://www.google.com/maps?q=${encodeURIComponent(query)}`;
  }
  return `https://www.google.com/maps?q=${market.location.lat},${market.location.lon}`;
}

type MarketHomeCardBodyProps = {
  marketInformation?: MarketInformation[];
};

const MarketHomeCardBody = ({
  marketInformation = [],
}: MarketHomeCardBodyProps) => {
  if (marketInformation.length === 0) return null;

  return (
    <div className="market-home-card-container">
      <ul className="market-home-card-list">
        {marketInformation.map((market) => (
          <li key={market.contentfulId} className="market-home-card-item">
            <a
              href={buildMapsUrl(market)}
              target="_blank"
              rel="noopener noreferrer"
              className="market-home-card-location"
            >
              {market.locationName}
              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                className="market-home-card-location-icon"
              />
            </a>

            <p className="market-home-card-schedule">
              {market.weekday} ·{" "}
              {formatMarketHours(market.startTime, market.endTime)}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MarketHomeCardBody;
